// https://app.growthbook.io/features/pen-7562_v1
export const EXPERIMENT_FLAG = 'pen-7562_v1'
